import {Component, OnChanges, SimpleChanges} from '@angular/core';
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {NgClass} from "@angular/common";
import {DxButtonComponent, DxDataGridComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent, DxoFilterRowComponent, DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent, DxoPagingComponent,
    DxoScrollingComponent, DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {UserAvatarEmailComponent} from "../../../../components/utils/user-avatar-email/user-avatar-email.component";
import {TimeOffRequestsComponent} from "../time-off-requests.component";
import {VacationGridViewDto} from "@services";
import {VacationPopupComponent} from "./vacation-popup/vacation-popup.component";
import {TimeOffFilterPanelComponent} from "../time-off-filter-panel/time-off-filter-panel.component";

@Component({
    selector: 'app-vacations',
    imports: [
        CapitalCasePipe,
        DxButtonComponent,
        DxDataGridComponent,
        DxTemplateDirective,
        DxiButtonComponent,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoScrollingComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        UserAvatarEmailComponent,
        NgClass,
        VacationPopupComponent,
        TimeOffFilterPanelComponent
    ],
    templateUrl: './vacations.component.html'
})
export class VacationsComponent extends TimeOffRequestsComponent<VacationGridViewDto> implements OnChanges {
    constructor() {
        super();
        this.init(VacationGridViewDto);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['employeeId']) {
            this.dataSource = this.dataSources.vacations(this.employeeId);
        }
    }

    dataSource = this.dataSources.vacations(null);
    filterModel: VacationGridViewDto = new VacationGridViewDto();
    gridFieldName = (name: keyof VacationGridViewDto): string => name;
    filterModelName = (name: keyof VacationGridViewDto): string => name;
    protected override exportName: string = "Vacations";
    protected tabName = 'vacation';

    getCellData(cellInfo: { data: VacationGridViewDto }) {
        return cellInfo.data;
    }
}
